import t from '@jetshop/intl';
import React, { useContext } from 'react';
import { useQuery } from '@apollo/react-hooks';
import PriceHistoryQuery from './PriceHistoryQuery.gql';
import { styled } from 'linaria/react';
import { Price } from '@jetshop/ui/Price';
import ChannelContext from '@jetshop/core/components/ChannelContext/ChannelContext';
import { theme } from '../../Theming/Theming';
import Spinner from '../../ui/Spinner';

const Wrapper = styled.div`
  --innerFontSize: 1rem;
  position: relative;

  .label {
    font-size: 0.75rem;
    cursor: pointer;
    background: transparent;
  }

  .price-table {
    .label {
      font-size: var(--innerFontSize);
    }

    li {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid ${theme.colors.border};
      padding: 5px 0;
      .timestamp {
        font-size: var(--innerFontSize);
      }

      [data-flight-price=''] {
        display: flex;
        > .price {
          font-size: var(--innerFontSize);
          font-weight: normal;
        }
      }
    }
  }
`;

export function PriceHistoryWrapper(props) {
  return (
    <Wrapper className="price-history-wrapper">
      <p>
        {t('Price history the latest {days} days from last change.', { days })}
      </p>
      <PriceHistory {...props} />
    </Wrapper>
  );
}

const days = 30;
function PriceHistory({ articleNumber, variant }) {
  const { error, loading, data } = useQuery(PriceHistoryQuery, {
    variables: { articleNumber, days },
    errorPolicy: 'all',
    skip: !articleNumber
  });

  if (loading || error) {
    return (
      <div className="price-table">
        {loading && <Spinner />}
        {error && <span className="label">{t('Something went wrong')}</span>}
      </div>
    );
  }

  const { product } = data;

  if (!variant) {
    return <Table history={product.history} days={days} />;
  }

  const selectedVariant = product.variants.values.find(
    value => value.articleNumber === variant.articleNumber
  );

  return <Table history={selectedVariant.history} days={days} />;
}

const Table = ({ history, days }) => {
  const { selectedChannel } = useContext(ChannelContext);

  if (history?.previousPrice?.length === 0) {
    return (
      <div className="price-table">
        <span className="label">
          {t('The price has not changed in the last { days } days', { days })}
        </span>
      </div>
    );
  }

  if (!history.previousPrice) {
    return (
      <div className="price-table">
        <span className="label">{t('Select variant')}</span>
      </div>
    );
  }

  return (
    <div className="price-table">
      <ul>
        {history.previousPrice?.map(({ timestamp, price }) => (
          <li key={timestamp}>
            <span className="timestamp">
              {new Date(timestamp).toLocaleDateString([
                selectedChannel.language.culture
              ])}
            </span>
            <Price price={price} as="span" />
          </li>
        ))}
      </ul>
    </div>
  );
};
